(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/prescript.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/prescript.js');

'use strict';

var _svs, _svs$tur, _svs$tur2, _svs$tur2$lyckoplatse, _svs$tur$lyckoplatsen, _svs$tur$lyckoplatsen2;
(_svs$tur = (_svs = svs).tur) !== null && _svs$tur !== void 0 ? _svs$tur : _svs.tur = {};
(_svs$tur2$lyckoplatse = (_svs$tur2 = svs.tur).lyckoplatsen) !== null && _svs$tur2$lyckoplatse !== void 0 ? _svs$tur2$lyckoplatse : _svs$tur2.lyckoplatsen = {};
(_svs$tur$lyckoplatsen2 = (_svs$tur$lyckoplatsen = svs.tur.lyckoplatsen).map) !== null && _svs$tur$lyckoplatsen2 !== void 0 ? _svs$tur$lyckoplatsen2 : _svs$tur$lyckoplatsen.map = {};

 })(window);